import apiClient from '@/services/axios'
import store from '@/store'

export async function login(email, password) {
  const options = {
    method: 'post',
    url: '/users/login',
    data: {
      user_email: email,
      user_password: password,
      user_role: store.state.settings.sellerType,
      vendor_name: store.state.settings.vendorName,
    },
  }
  return apiClient(options)
    .then(response => {
      if (response) {
        const { token } = response.data
        if (token) {
          store.commit('user/SET_STATE', {
            accessToken: token,
          })
        }
        return response
      }
      return false
    })
    .catch(err => {
      return err.response
    })
}

export async function register(email, password, name) {
  return apiClient
    .post('/users/register', {
      email,
      password,
      name,
    })
    .then(response => {
      if (response) {
        const { token } = response.data
        if (token) {
          store.set('accessToken', token)
        }
        return response
      }
      return false
    })
    .catch(err => {
      console.log(err)
    })
}

export async function currentAccount() {
  return apiClient
    .get('/auth/account')
    .then(response => {
      if (response) {
        const { accessToken } = response.data
        if (accessToken) {
          store.set('accessToken', accessToken)
        }
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function logout() {
  return apiClient
    .get('/users/logout')
    .then(() => {
      store.remove('accessToken')
      return true
    })
    .catch(err => console.log(err))
}
export function resetpassconf(hashId, token) {
  store.commit('user/LOGOUT') /* hanya untuk clear accesToken */
  store.commit('user/SET_STATE', {
    confirmpass: {
      link: '',
      token: '',
    },
  })
  const options = {
    method: 'get',
    url: `/users/passwd?hashId=${hashId}&token=${token}`,
  }
  return apiClient(options)
    .then(response => {
      if (response) {
        const { token } = response.data
        if (token) {
          const { user, link } = response.data
          store.commit('user/SET_STATE', {
            email: user.user_email,
            confirmpass: {
              link,
              token,
            },
          })
        }
      }
      return {
        success: true,
        response,
      }
    })
    .catch(err => {
      const { response } = err
      return {
        success: false,
        code: response?.status,
      }
    })
}
